import { createApp } from "vue";
import App from "./App.vue";
import naive from "naive-ui";

const app = createApp(App);
app.config.errorHandler = function (err, vm, info) {
  console.error({
    error: err,
    params: { info: info },
  });
};

app.use(naive);

window.addEventListener(
  "load",
  function (event) {
    app.mount("#wp-vue-quiz");
  },
  false
);
